const WaybillPaperSizeEnum = Object.freeze({
    A4: "a4",
    A5: "a5",
    A6: "a6"
});

export default WaybillPaperSizeEnum;
